import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/cdn/theme2/images/left-arrow.svg")